<template>
  <div class="yk-home-mul-wrapper">
    <el-form ref="formOption"
             class="yk-multiselect"
             label-width="100px"
             label-position="left">
      <el-form-item label="题目：">
        <div v-if="IsTitle">
          <Editor placeholder="请输入内容" />
        </div>
        <div v-else
             class="yk-claer-style-margin">
          <span v-html="data.Content"
                class="yk-multiselect-question  yk-span-wrapper"></span>
        </div>
      </el-form-item>
      <el-form-item label="题目附件：" v-if="filesList.length > 0">
          <div v-if="IsTitle">
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
          <div v-else>
            <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
          </div>
      </el-form-item>
      <div>
        <div v-if="IsSelects">
          <el-form-item label="选项：">
            <el-form-item label-width="30px"
                          v-for="(question,index) in questions"
                          :key="question">
              <el-checkbox-group v-model="check">
                <el-checkbox :label="question.choice"
                             @change="addCheckValue"></el-checkbox>
                <el-input placeholder="请输入选项内容"></el-input>
                <i class="el-icon-close"
                   @click="closeChoice(index)"></i>
              </el-checkbox-group>
            </el-form-item>
          </el-form-item>
          <span @click="addChoice"
                class="yk-addChoice">
            <i class="el-icon-circle-plus"></i>
            添加选项
          </span>
        </div>
        <div v-else>
          <el-form-item label="选项：">
            <el-form-item v-for="(question,index) in questions"
                          :key="question">
              <span style="float:left">{{alphabet[index]}}.</span>
              <span v-html="question"
                    class="yk-span-wrapper-s"></span>
            </el-form-item>
          </el-form-item>
        </div>
      </div>
      <el-form-item label="答案："
                    v-show="IsAnswers">
        <span v-for="(CheckValue,CheckValueIndex) in CheckValues"
              :key="CheckValue">{{ alphabet[CheckValue]}}<span v-if="CheckValueIndex != CheckValues.length-1">、</span></span>
      </el-form-item>
      <el-form-item label="解析："
                    v-if="showThisAnswer">
        <!-- <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" /> -->
        <div v-html="data.Analysis">
          {{data.Analysis}}
        </div>
      </el-form-item>
      <el-form-item label="解析附件："
          v-if="showThisAnswer && analysisFilesList.length > 0">
          <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
      </el-form-item> 
    </el-form>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="anaShow">
      <i class="el-icon-arrow-up"></i>
      <span>收起解析</span>
    </div>
    <div class="yk-mm-up-down-wrapper"
         @click="upDown"
         v-if="!anaShow">
      <i class="el-icon-arrow-down"></i>
      <span>查看解析</span>
    </div>
  </div>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionFileNew.vue';
export default {
  name: 'multiselects',
  components: {
    QuestionFile
  },
  props: {
    isBook:{
      type: Boolean,
      default: true
    },
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Boolean,
      default: true
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  created() {
    this.cont = this.data;
    this.questions = this.data.Selects;
    this.CheckValues = this.data.Answers;
    this.content = this.data.Analysis;
    // 题目附件
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
    let selectLength = this.data.Selects.length;
    if(selectLength > 26){
      for(let i= 0;i < selectLength-26;i++){
        let indexStr = this.alphabet[parseInt(i/26)] +this.alphabet[i%26];
        this.alphabet.push(indexStr);
      }
    }
  },
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      showThisAnswer: true,
      anaShow: true,
      cont: [],
      content: '请输入内容',
      formOption: {
        choice: null
      },
      questions: [
        {
          id: 0,
          choice: 'A',
          contrary: false
        },
        {
          id: 1,
          choice: 'B',
          contrary: false
        },
        {
          id: 2,
          choice: 'C',
          contrary: false
        },
        {
          id: 3,
          choice: 'D',
          contrary: false
        },
        {
          id: 4,
          choice: 'E',
          contrary: false
        },
        {
          id: 5,
          choice: 'F',
          contrary: false
        },
        {
          id: 6,
          choice: 'G',
          contrary: false
        }
      ],
      a: 1,
      CheckValues: [],
      check: [],
      alphabet: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ]
    };
  },
  watch: {
    'data.ContentText': {
      handler: function() {
        this.questions = this.data.Selects;
        this.CheckValues = this.data.Answers;
        this.content = this.data.Analysis;
        this.cont = this.data;
      },
      deep: true
    }
  },
  methods: {
    upDown() {
      this.showThisAnswer = !this.showThisAnswer;
      this.anaShow = !this.anaShow;
    },
    // 添加选项
    addChoice: function() {
      var n = this.questions.length;
      var str = { id: n, contrary: false, choice: this.alphabet[n] };
      this.questions.push(str);
      this.CheckValues.push(null);
    },
    // 删除选项
    closeChoice: function(index) {
      for (var i = 0; i <= index; i++) {
        this.questions[i].choice = this.alphabet[i];
      }
      this.questions.splice(index, 1);
      this.CheckValues = this.check;
    },
    // 添加正确答案
    addCheckValue: function() {
      this.CheckValues = this.check;
    },

    // 答案选项
    GetAnswer(choose) {
      if (choose === '0') {
        return 'A';
      } else if (choose === '1') {
        return 'B';
      } else if (choose === '2') {
        return 'C';
      } else if (choose === '3') {
        return 'D';
      } else if (choose === '4') {
        return 'E';
      } else if (choose === '5') {
        return 'F';
      } else if (choose === '6') {
        return 'G';
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss">
@import '~theme/page/components/variables.scss';
.yk-home-mul-wrapper {
  position: relative;
  padding-right: 20px;
  padding-left: 20px;
  .yk-multiselect {
    .el-form-item {
      margin-bottom: 20px;
      .el-form-item__label {
        color: #000;
      }
      .el-form-item__content {
        font-size: 16px;
        color: #000;
      }
    }
    .el-input {
      width: 85%;
      margin-left: 15px;
    }
    i.el-icon-close {
      font-size: 15px;
      margin-left: 10px;
    }
    
    .el-col .yk-addChoice {
      margin-left: 70px;
      color: rgba(255, 255, 255, 1);
    }
    .el-label {
      text-align: right;
      vertical-align: middle;
      float: left;
      font-size: 14px;
      line-height: 40px;
      padding: 0 12px 0 0;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
  }
  .el-form-item__label {
    color: #000;
  }
  .yk-mm-up-down-wrapper {
    position: absolute;
    width: 240px;
    height: 30px;
    background: #F5F5F5;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
    bottom: -50px;
    left: 50%;
    margin-left: -120px;
    border-radius: 0 0 30px 30px;
    text-align: center;
    line-height: 30px;
  }
}
</style>

